import { create } from 'zustand';
import AsyncStorage from '@react-native-async-storage/async-storage';

const STORAGE_KEY = '@tablePreferences:v1';

const persistTables = async (tables) => {
    try {
        await AsyncStorage.setItem(STORAGE_KEY, JSON.stringify(tables));
    } catch {
        return;
    }
};

const useTablePreferencesStore = create((set, get) => ({
    tables: {},
    isHydrated: false,

    hydrate: async () => {
        if (get().isHydrated) return;
        try {
            const stored = await AsyncStorage.getItem(STORAGE_KEY);
            const parsed = stored ? JSON.parse(stored) : {};
            if (parsed && typeof parsed === 'object' && !Array.isArray(parsed)) {
                set({ tables: parsed, isHydrated: true });
                return;
            }
        } catch {
            set({ isHydrated: true });
            return;
        }
        set({ isHydrated: true });
    },

    setColumnIds: (tableId, columnIds) => {
        const tables = {
            ...get().tables,
            [tableId]: { ...get().tables[tableId], columnIds },
        };
        set({ tables });
        persistTables(tables);
    },

    setViewMode: (tableId, viewMode) => {
        const tables = {
            ...get().tables,
            [tableId]: { ...get().tables[tableId], viewMode },
        };
        set({ tables });
        persistTables(tables);
    },
}));

export default useTablePreferencesStore;
